import type { RefObject } from 'react';
import type { RichTextEditorRef } from '@cotera/client/app/components/app/rte';
import { DG } from '@cotera/sdk/core';

export type AgentSeedPersistSnapshot = {
  editorState: DG.DocumentEditor.DocumentState;
  model: string;
};

type AgentSeedRuntime = {
  editorRef: RefObject<RichTextEditorRef | null>;
  getPersistSnapshot: () => AgentSeedPersistSnapshot;
  markPersisted: () => void;
};

const runtimesByAgentId = new Map<string, AgentSeedRuntime>();

export function registerAgentSeedRuntime(
  agentId: string,
  runtime: AgentSeedRuntime
): () => void {
  runtimesByAgentId.set(agentId, runtime);
  return () => {
    if (runtimesByAgentId.get(agentId) === runtime) {
      runtimesByAgentId.delete(agentId);
    }
  };
}

export function getAgentSeedRuntime(
  agentId: string
): AgentSeedRuntime | undefined {
  return runtimesByAgentId.get(agentId);
}
